import * as React from 'react';
import { SVGProps } from 'react';

const IconCameraSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 15a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.618 4a1 1 0 0 0-.894.553L8 7H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4l-.724-2.447A1 1 0 0 0 18.382 4H9.618ZM20 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
    />
  </svg>
);
export default IconCameraSizeL;
